import apiConfig from 'src/integration/config/apiConfig';
import useUrlBuilder from 'src/toolkit/utils/useUrlBuilder';

const useUrlJavaBuilder = () => {
  const { buildPathWithQueryParams } = useUrlBuilder();

  const resolveJavaUrl = (endpoint: string, queryParams?: SimpleObject, queryPath?: SimpleObject): string => {
    const baseUrl = apiConfig.api.baseJavaUrl;

    if (!baseUrl) {
      throw new Error('Base URL is not defined.');
    }

    const normalizedBaseUrl = baseUrl.replace(/\/$/, '');
    const normalizedPath = endpoint.replace(/^\//, '');
    const pathWithQuery = buildPathWithQueryParams(normalizedPath, queryParams, queryPath);

    return `${normalizedBaseUrl}/${pathWithQuery}`;
  };

  return {
    resolveJavaUrl,
  };
};

export default useUrlJavaBuilder;
